import { Injectable } from '@angular/core';
import { MagazineAdapter } from '@modules/content-api/adapter/magazine.adapter';
import { ContentAPIService } from '@modules/content-api/content-api.service';
import { map } from 'rxjs/operators';

import { MAGAZINE_PAGE_PARAMS } from './magazine-page.service';

@Injectable({
  providedIn: 'root',
})
export class TopicPageService {
  constructor(private apiService: ContentAPIService, private magazineAdapter: MagazineAdapter) {}

  public getTopicPage(fullPath: string) {
    return this.apiService
      .getResources('topic_pages', MAGAZINE_PAGE_PARAMS.append('filter[slug.value]', `/topic-page${fullPath}`))
      .pipe(
        map((data) => {
          try {
            return this.magazineAdapter.parse(data[0] ?? null);
          } catch (error) {
            // Additional error handling for parse errors?
            return null;
          }
        })
      );
  }
}
